(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('SignupController', SignupController);

    SignupController.$inject = ['$window', '$state', '$location', 'Signup', 'AlertService'];

    function SignupController ($window, $state, $location, Signup, AlertService) {
        var vm = this;

        var termsUrl = "./content/terms-privacy/terms-conditions.pdf";
        var privacyUrl = "./content/terms-privacy/privacy.pdf";
        vm.passwordnotmatch = " ";
        vm.checkTerms = false;
        vm.checkPrivacy = false;
        vm.check1 = false;
        vm.disabled = true;

        vm.checkDisabled = "Please view both links";

        vm.user = {};
        vm.nextOptions = false;
        vm.success = false;

        vm.checkMinLngUser = true;

        vm.init = function () {
            var key = $location.search().invitationKey;
            Signup.getInvitation({invitationKey: key}, onGetSuccess, onGetError);

            function onGetSuccess(data) {
                vm.user.email = data.email;
                vm.user.authority = data.authority.name;
                vm.user.invitationKey = key;
                vm.user.createdBy = data.invitedBy;
            }

            function onGetError() {
                vm.user = null;
            }
        }

        vm.save = function () {
            Signup.registerNewUser(vm.user, onSaveSuccess, onSaveError);

            function onSaveSuccess() {
                AlertService.success("User Created.");
                vm.success = true;
            }

            function onSaveError(error) {
                console.log(error);
            }
        };

        vm.termsAgree = function() {
            $window.open(termsUrl);
            vm.checkTerms = true;
            if(vm.checkTerms && vm.checkPrivacy){
                vm.disabled = false;
                vm.checkDisabled = "";
            }
        };

        vm.privacyAgree = function() {
            $window.open(privacyUrl);
            vm.checkPrivacy = true;
            if(vm.checkTerms && vm.checkPrivacy){
                vm.disabled = false;
                vm.checkDisabled = "";
            }
        };

        vm.changeOptions = function() {
            vm.nextOptions = !vm.nextOptions;
        }

        vm.goToLogin = function() {
            $state.go('login');
        }
        vm.passwordmatch = function()
        {
            if(vm.user.password === vm.user.confirmPassword)
                vm.passwordnotmatch = " ";
            else
                vm.passwordnotmatch = "Password does not match";
        }
        vm.checkUserLng = function() {
            vm.checkMinLngUser = checkMinLength(vm.user.login, 7) || checkMinLength(vm.user.firstName, 0)
                || checkMinLength(vm.user.lastName, 0) || checkMinLength(vm.user.password, 8)
                || checkMinLength(vm.user.confirmPassword, 8) || (vm.user.password !== vm.user.confirmPassword);
            if(vm.checkMinLngUser)
                    vm.passwordnotmatch = " ";
        }

        function checkMinLength(inputVar, minLng) {
            return inputVar === undefined || inputVar < minLng;
        }
    }
})();
